module.exports = __webpack_public_path__ + "static/media/08.067e0ffe.mp3";